import { useCallback, useState } from 'react';
import * as Tabs from '@radix-ui/react-tabs';
import PANEL_CAPABILITIES from '../../../shared/panelCapabilities';
import AvaChat, { SESSION_KEY } from './AvaChat';
import AvaHistory from './AvaHistory';
import AvaPushToggle from './AvaPushToggle';

const SECTIONS = [
  { value: 'chat', label: 'گفتگو', capability: 'ai.ava.chat' },
  { value: 'history', label: 'تاریخچه', capability: 'ai.ava.history' },
];

// «آوا» admin tab: a two-pill RTL subtab strip over the chat card. The chat
// content stays mounted so switching tabs never interrupts an in-flight stream.
export default function AvaTab({ role }) {
  const visibleSections = SECTIONS.filter(({ capability }) => (
    PANEL_CAPABILITIES.canAccessPanelSection(role, capability)
  ));
  const visibleValues = new Set(visibleSections.map(({ value }) => value));
  const defaultTab = visibleSections[0]?.value || '';
  const canChat = visibleValues.has('chat');
  const [chatEpoch, setChatEpoch] = useState(0);
  const [tab, setTab] = useState(defaultTab);
  const selectedTab = visibleValues.has(tab) ? tab : defaultTab;

  const remountChat = useCallback(() => {
    setChatEpoch((n) => n + 1);
    setTab(canChat ? 'chat' : defaultTab);
  }, [canChat, defaultTab]);

  const onNewChat = useCallback(() => {
    localStorage.removeItem(SESSION_KEY);
    remountChat();
  }, [remountChat]);

  if (visibleSections.length === 0) {
    return <div className="ava-tab" role="status">شما به هیچ بخش آوا دسترسی ندارید.</div>;
  }

  return (
    <div className="ava-tab" dir="rtl">
      {visibleValues.has('chat') && <AvaPushToggle />}
      <Tabs.Root className="ava-subtabs" value={selectedTab} onValueChange={setTab} orientation="horizontal" dir="rtl">
        <div className="ava-subtabs-row">
          <Tabs.List className="admin-subnav" aria-label="بخش‌های آوا">
            {visibleSections.map(({ value, label }) => (
              <Tabs.Trigger className="admin-subtab" value={value} key={value}>{label}</Tabs.Trigger>
            ))}
          </Tabs.List>
          {visibleValues.has('chat') && (
            <button type="button" className="ava-newchat" onClick={onNewChat} title="گفتگوی جدید">
              <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
                <path d="M12 5v14M5 12h14" />
              </svg>
              <span className="ava-newchat-label">گفتگوی جدید</span>
            </button>
          )}
        </div>
        {visibleValues.has('chat') && (
          <Tabs.Content value="chat" forceMount className="admin-subtab-content">
            <AvaChat key={chatEpoch} />
          </Tabs.Content>
        )}
        {visibleValues.has('history') && (
          <Tabs.Content value="history" className="admin-subtab-content">
            <AvaHistory onResume={remountChat} />
          </Tabs.Content>
        )}
      </Tabs.Root>
    </div>
  );
}
